import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Customer } from '../classes/customer';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    API_CUSTOMER_URL = config.serverAddress + ':' + config.serverPort + '/customer/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get<Array<Customer>>(this.API_CUSTOMER_URL + 'all');
    }
    getByVATNumber(vatNumber: string | null) {
        return this.http.get<Customer>(this.API_CUSTOMER_URL + 'vat/' + encodeURIComponent(vatNumber ?? ''));
    }
    getByID(id: string | null) {
        return this.http.get<Customer>(this.API_CUSTOMER_URL + id);
    }
    create(customer: Customer) {
        return this.http.post<Customer>(this.API_CUSTOMER_URL + 'create', customer);
    }
    update(customer: Customer) {
        return this.http.put<Customer>(this.API_CUSTOMER_URL + 'update', customer);
    }
    delete(id: number | undefined) {
        return this.http.delete(this.API_CUSTOMER_URL + 'delete/' + id);
    }
}
